export { default } from "./buildTemplateList";
